module.exports = {
      id: "apple-usage",
      viewBox: "0 0 56 56",
      url: __webpack_public_path__ + "svg-sprite-0a04d67e7be2467ff8c30ec762f261a0.svg#apple",
      toString: function () {
        return this.url;
      }
    }